import React from 'react';

export const GlassSurface = ({
  children,
  className = '',
  inner = false,
  level = 'l2', // 'l1', 'l2', 'l3'
  padding = 'var(--glass-sp-12)',
  margin = 'var(--glass-sp-8) var(--glass-sp-12)',
  borderRadius = 'var(--glass-radius)',
  ...props
}) => {
  let surfaceClass = 'glass-surface';
  
  if (inner) {
    surfaceClass = 'glass-surface-inner';
  } else if (level === 'l3') {
    surfaceClass = 'glass-surface-l3';
  }
  
  return (
    <div
      className={`${surfaceClass} ${className}`}
      style={{
        padding,
        margin,
        borderRadius,
        ...props.style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export const GlassCard = (props) => (
  <GlassSurface {...props} className={`glass-card ${props.className || ''}`} />
);

export const GlassSection = (props) => (
  <GlassSurface {...props} className={`glass-section ${props.className || ''}`} />
);